import axios from "axios";
import {
  DEPARTMENT_LIST_REQUEST,
  DEPARTMENT_LIST_SUCCESS,
  DEPARTMENT_LIST_FAIL,
  CATEGORY_LIST_REQUEST,
  CATEGORY_LIST_SUCCESS,
  CATEGORY_LIST_FAIL,
  CATEGORY_SINGLE_REQUEST,
  CATEGORY_SINGLE_SUCCESS,
  CATEGORY_SINGLE_FAIL,
  CATEGORY_SEARCH_REQUEST,
  CATEGORY_SEARCH_SUCCESS,
  CATEGORY_SEARCH_FAIL,
  ADD_CATEGORY_FAIL,
  ADD_CATEGORY_REQUEST,
  ADD_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAIL,
  DELETE_CATEGORY_REQUEST,
  DELETE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_REQUEST,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAIL,
} from "./categoryTypes";
import { BACK_URI } from "../../config/keys";
import { setAlert, removeAlert } from "../Alert/alert.actions";

export const listDepartments = () => async (dispatch) => {
  try {
    dispatch({ type: DEPARTMENT_LIST_REQUEST });

    const { data } = await axios.get(`${BACK_URI}/department`);
    dispatch({
      type: DEPARTMENT_LIST_SUCCESS,
      payload: data,
    });
    // localStorage.setItem("categories", JSON.stringify(data));
  } catch (error) {
    dispatch({
      type: DEPARTMENT_LIST_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const listAllCategories = () => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_LIST_REQUEST });

    const { data } = await axios.get(`${BACK_URI}/category`);
    dispatch({
      type: CATEGORY_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CATEGORY_LIST_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const listAllBlogCategories = () => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_LIST_REQUEST });

    const { data } = await axios.get(`${BACK_URI}/blog/category`);
    dispatch({
      type: CATEGORY_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CATEGORY_LIST_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const singleCategory = (cat) => async (dispatch) => {
  try {
    dispatch({ type: CATEGORY_SINGLE_REQUEST });

    const { data } = await axios.get(`${BACK_URI}/category/${cat}`);
    dispatch({
      type: CATEGORY_SINGLE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CATEGORY_SINGLE_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};
export const searchCat = (name) => async (dispatch, getState) => {
  try {
    dispatch({ type: CATEGORY_SEARCH_REQUEST });
    const {
      userState: { userInfo },
    } = getState();
    const config = {
      headers: {
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.get(`${BACK_URI}/category/search/${name}`, config);
    dispatch({
      type: CATEGORY_SEARCH_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CATEGORY_SEARCH_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};
export const listCategories = (slug) => async (dispatch, getState) => {
  try {
    dispatch({ type: CATEGORY_LIST_REQUEST });

    const { data } = await axios.get(`${BACK_URI}/department/categories/${slug}`);
    dispatch({
      type: CATEGORY_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: CATEGORY_LIST_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const deleteCategories = (slug, category) => async (dispatch, getState) => {
  try {
    dispatch({ type: DELETE_CATEGORY_REQUEST });
    dispatch(setAlert("", "loading"));

    const {
      userState: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: userInfo.token,
      },
    };

    const { data } = await axios.delete(`${BACK_URI}/category/${slug}`, config);
    dispatch({
      type: DELETE_CATEGORY_SUCCESS,
      payload: data,
    });
    dispatch(setAlert("SubCategorie Removed Succesfully", "success", 2000));
    dispatch(listCategories(category));
  } catch (error) {
    dispatch(setAlert("", "error", 2500));
    dispatch({
      type: DELETE_CATEGORY_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const addCategories = (category, body) => async (dispatch, getState) => {
  try {
    dispatch({ type: ADD_CATEGORY_REQUEST });
    const {
      userState: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.post(`${BACK_URI}/category`, body, config);

    dispatch({
      type: ADD_CATEGORY_SUCCESS,
      payload: data,
    });

    dispatch(listCategories(category));
    dispatch(setAlert(`${body.name} Added SuccessFully`, "success", 1500));
  } catch (error) {
    dispatch(setAlert("", "error", 2500));
    dispatch({
      type: ADD_CATEGORY_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};

export const updateCategory = (body) => async (dispatch, getState) => {
  try {
    dispatch({ type: UPDATE_CATEGORY_REQUEST });
    const {
      userState: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: userInfo.token,
      },
    };
    const { data } = await axios.put(`${BACK_URI}/category/${body.slug}`, body, config);
    dispatch({
      type: UPDATE_CATEGORY_SUCCESS,
      payload: data,
    });

    dispatch(singleCategory(body.slug));
    dispatch(setAlert(`Updated SuccessFully`, "success", 1500));
  } catch (error) {
    dispatch(setAlert("", "error", 2500));
    dispatch({
      type: UPDATE_CATEGORY_FAIL,
      payload: error.response && error.response.data.msg ? error.response.data.msg : error.msg,
    });
  }
};
